/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Error_Artifact_FailedInputs */



/**
* | output |
* | --- |
* | "Error processing the created artifact" |
*
* @param {Distillation_Error_Artifact_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_error_artifact_failed = /** @type {((inputs?: Distillation_Error_Artifact_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Error_Artifact_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Verarbeiten des erstellten Artefakts")
	return /** @type {LocalizedString} */ ("Error processing the created artifact")
});